/*
 * tm-article-faq : transforme la FAQ écrite dans le contenu d'un article en accordéon.
 * Fichier ajouté, aucun fichier d'origine modifié. Le texte de l'article n'est pas modifié dans Shopify :
 * la transformation se fait à l'affichage, et sans JavaScript la FAQ reste lisible telle quelle.
 *
 * Formats reconnus, après un titre « FAQ… » ou « Questions fréquentes » :
 *  - un sous-titre se terminant par « ? », suivi d'un ou plusieurs blocs de réponse ;
 *  - un paragraphe qui commence par la question en gras (« ? »), puis la réponse.
 * La FAQ s'arrête au prochain titre de même niveau (ou supérieur), ou à un sous-titre
 * qui n'est pas une question (ex. « Sources »).
 */
(function () {
  var config = document.getElementById('tm-article-faq-config');
  var content = document.querySelector('.articles__content');
  if (!config || !content || content.querySelector('.tm-faq')) return;

  var options = {
    singleOpen: config.dataset.singleOpen === 'true',
    openFirst: config.dataset.openFirst === 'true',
    font: config.dataset.font || 'heading',
    structuredData: config.dataset.structuredData === 'true'
  };

  var FAQ_TITLE = /\bfaq\b|questions?\s+fr[ée]quentes|vos\s+questions/i;
  var HEADING = /^H[1-6]$/;

  function level(el) {
    return HEADING.test(el.tagName) ? parseInt(el.tagName.charAt(1), 10) : 0;
  }
  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function isQuestion(str) {
    return /\?\s*$/.test(str);
  }
  function isEmpty(el) {
    return text(el) === '' && !el.querySelector('img, iframe, video, table');
  }
  // Paragraphe « <strong>Question ?</strong><br>Réponse »
  function boldQuestion(el) {
    if (el.tagName !== 'P') return null;
    var first = el.firstElementChild;
    if (!first || !/^(STRONG|B)$/.test(first.tagName)) return null;
    var before = el.innerHTML.split(first.outerHTML)[0];
    if (before.replace(/&nbsp;|\s/g, '') !== '') return null;
    return isQuestion(text(first)) ? first : null;
  }

  var title = Array.prototype.find.call(content.querySelectorAll('h2, h3, h4'), function (h) {
    return FAQ_TITLE.test(text(h));
  });
  if (!title) return;

  var titleLevel = level(title);
  var items = [];
  var current = null;
  var node = title.nextElementSibling;

  while (node) {
    var next = node.nextElementSibling;
    var lvl = level(node);

    if (lvl && lvl <= titleLevel) {
      if (isEmpty(node)) {
        node = next;
        continue;
      }
      break;
    }

    if (lvl) {
      if (isQuestion(text(node))) {
        current = { question: node, answers: [] };
        items.push(current);
      } else if (!isEmpty(node)) {
        break;
      }
    } else {
      var strong = boldQuestion(node);
      if (strong) {
        var question = document.createElement('span');
        question.innerHTML = strong.innerHTML;
        var answer = node.cloneNode(true);
        answer.removeChild(answer.firstElementChild);
        while (answer.firstChild && (answer.firstChild.nodeName === 'BR' || (answer.firstChild.nodeType === 3 && !answer.firstChild.textContent.trim()))) {
          answer.removeChild(answer.firstChild);
        }
        current = { question: question, answers: [answer], source: node };
        items.push(current);
      } else if (current) {
        current.answers.push(node);
      } else if (!isEmpty(node)) {
        break;
      }
    }
    node = next;
  }

  if (items.length < 1) return;

  // Ancre #faq utilisée par les sommaires des articles
  if (!title.id && !document.getElementById('faq')) title.id = 'faq';

  var wrapper = document.createElement('div');
  wrapper.className = 'tm-faq tm-faq--font-' + options.font;
  var anchor = items[0].source || items[0].question;
  anchor.parentNode.insertBefore(wrapper, anchor);

  items.forEach(function (item, index) {
    var details = document.createElement('details');
    details.className = 'tm-faq__item';
    if (options.openFirst && index === 0) details.open = true;

    var summary = document.createElement('summary');
    summary.className = 'tm-faq__q';
    var label = document.createElement('span');
    label.className = 'tm-faq__q-text';
    label.appendChild(item.question);
    var icon = document.createElement('span');
    icon.className = 'tm-faq__icon';
    icon.setAttribute('aria-hidden', 'true');
    summary.appendChild(label);
    summary.appendChild(icon);

    var body = document.createElement('div');
    body.className = 'tm-faq__a';
    item.answers.forEach(function (el) {
      if (!isEmpty(el)) body.appendChild(el);
      else if (el.parentNode) el.parentNode.removeChild(el);
    });
    if (item.source && item.source.parentNode) item.source.parentNode.removeChild(item.source);

    details.appendChild(summary);
    details.appendChild(body);
    wrapper.appendChild(details);
    item.details = details;
  });

  if (options.singleOpen) {
    wrapper.addEventListener(
      'toggle',
      function (event) {
        if (!event.target.open) return;
        items.forEach(function (item) {
          if (item.details !== event.target) item.details.open = false;
        });
      },
      true
    );
  }

  // Données structurées FAQPage (si l'article n'en contient pas déjà)
  if (options.structuredData) {
    var hasFaqSchema = Array.prototype.some.call(
      document.querySelectorAll('script[type="application/ld+json"]'),
      function (s) {
        return /"FAQPage"/.test(s.textContent);
      }
    );
    if (!hasFaqSchema) {
      var data = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items.map(function (item) {
          return {
            '@type': 'Question',
            name: text(item.question),
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answers
                .map(function (el) {
                  return text(el);
                })
                .filter(Boolean)
                .join(' ')
            }
          };
        })
      };
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    }
  }
})();
